import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBT = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M42.677 42.678c-9.763 9.763-25.592 9.763-35.355 0-9.763-9.763-9.763-25.592 0-35.355.004 0 22.467-6.638 32.23 3.125 9.763 9.763 3.132 32.223 3.125 32.23Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M42.677 42.678c9.763-9.763 9.763-25.592 0-35.356-9.763-9.763-25.592-9.763-35.355 0l35.355 35.356Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M31.535 31.537a3.8 3.8 0 0 1-3.255-.22 3.808 3.808 0 0 1-1.456-5.18l-.311-.175c3.132-.755 5.449-3.598 5.408-6.953a7.048 7.048 0 0 0-2.415-5.228l-2.282 2.339a3.798 3.798 0 0 1 1.436 2.929 3.808 3.808 0 0 1-3.757 3.85l.004.357c-2.22-2.334-5.84-2.92-8.725-1.207a7.05 7.05 0 0 0-3.32 4.705l3.166.808a3.799 3.799 0 0 1 1.818-2.709 3.809 3.809 0 0 1 5.214 1.33l.307-.183c-.912 3.09.391 6.518 3.317 8.16a7.05 7.05 0 0 0 5.735.523l-.884-3.146Zm-6.606-6.464Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFEACF",
  d: "m34.257 16.933-1.767 6.305-5.302-.979-3.413-7.034-9.219 3.271-.727-2.049-2.412-.297 1.817 5.122 6.345-1.622 1.803 5.08-4.386 6.473 7.443 6.348-1.41 1.654.948 2.238 3.527-4.135-4.578-4.683 3.5-4.102 7.798.562L36 19.465l2.138.395 1.464-1.94-5.345-.988Zm-9.259 8.238Z"
}));
FlagBT.displayName = 'FlagBT';
export default withFlagWrapper(FlagBT);
//# sourceMappingURL=index.js.map